import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/options',
    name: 'options',
    component: () => import('../views/options.vue')
  },
  {
    path: '/login',
    name: 'admin-login',
    component: () => import('../views/admin/login.vue')
  },
  {
    path: '/admin/services',
    name: 'admin-services',
    component: () => import('../views/admin/services.vue')
  },
  {
    path: '/admin/plan',
    name: 'admin-plan',
    component: () => import('../views/admin/plan.vue')
  },
  {
    path: '/admin/plan-add',
    name: 'admin-plan-add',
    component: () => import('../views/admin/plan-add.vue')
  },
  {
    path: '/admin/plan-edit',
    name: 'admin-plan-edit',
    component: () => import('../views/admin/plan-edit.vue')
  },
  {
    path: '/admin/options',
    name: 'admin-options',
    component: () => import('../views/admin/options.vue')
  },
  // error-404
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/error404.vue'),
  },
  {
    path: '*',
    component: () => import('@/views/error/error404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
